// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"59c57210","977":"7f2e309d"}[chunkId] + ".chunk.js";
};